import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseSiteService, OccEndpointsService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-product-details-influenza',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './product-details-influenza.component.html',
  styleUrls: ['./product-details-influenza.component.scss'],
})
export class ProductDetailsInfluenzaComponent implements OnInit, OnDestroy {
  @Input() public productDetails;
  @Input() public standardCartCode;
  @Input() public checkout = false;

  baseUrl: any;
  monograph: any;
  monographLink: any;
  baseSub: Subscription;
  baseSiteId: any;
  constructor(
    private readonly modalService: NgbModal,
    private readonly occEndPoint: OccEndpointsService,
    private readonly baseSiteService: BaseSiteService
  ) {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }

  ngOnInit(): void {
    this.monograph = this.productDetails?.productDocuments;
    if (this.monograph) {
      for (const link of this.monograph?.productDocument) {
        this.monographLink = link.url;
      }
    }
    this.baseSub = this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
  }
  close(): void {
    this.modalService.dismissAll();
  }
  ngOnDestroy(): void {
    this.baseSub?.unsubscribe();
  }
}
